import { LOGISTICCOMPANY_PREPARE_CHANGE } from "state/auth";
import { FETCH_TRACK } from "./index";

const initialState = {
  tracking: null,
  code: null,
  loaded: false,
  error: null
};

export default function auth(state = initialState, action = {}) {
  const { type, payload, error } = action;

  switch (type) {
    case FETCH_TRACK:
      if (error) {
        return {
          ...state,
          error: payload,
          loaded: true
        };
      }

      return {
        tracking: payload.tracking.tracking[0],
        code: payload.code,
        loaded: true,
        error: null
      };

    case LOGISTICCOMPANY_PREPARE_CHANGE:
      return initialState;

    default:
      return state;
  }
}
